import * as Yup from 'yup';

import { validateProducts } from 'utils/validation';
import { StockTransferType } from 'store/api/stock-transfers';
import { ltlInvoiceNumberSchema } from 'utils/ltl-invoice-number';
import { eventSplitSchema } from 'components/stock-transfer-event-split/config';

export const validationSchema = Yup.object().shape({
  ...validateProducts('items'),
  type: Yup.string().required(),
  ltlInvoiceNumber: ltlInvoiceNumberSchema,
  date: Yup.string().required('Date is required'),
  sourceStorageId: Yup.number().required('Source storage is required'),
  // T-L09 (L14): the optional event split, Storage -> Storage only.
  events: Yup.array().when('type', {
    then: () => eventSplitSchema('ltlPrice'),
    is: (value: StockTransferType) =>
      value === StockTransferType.StorageToStorage,
  }),
  destinationCompanyId: Yup.number()
    .nullable()
    .when('type', {
      then: (schema) => schema.required('Destination company is required'),
      is: (value: StockTransferType) =>
        value === StockTransferType.ClientToClient,
    }),
  destinationStorageId: Yup.number()
    .nullable()
    .when('type', {
      then: (schema) => schema.required('Destination storage is required'),
      is: (value: StockTransferType) =>
        value !== StockTransferType.ClientToClient,
    }),
});
